import { render, staticRenderFns } from "./Servicios.vue?vue&type=template&id=db155594&scoped=true&"
import script from "./Servicios.vue?vue&type=script&lang=js&"
export * from "./Servicios.vue?vue&type=script&lang=js&"
import style0 from "./Servicios.vue?vue&type=style&index=0&id=db155594&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db155594",
  null
  
)

export default component.exports